export const showOnboardingStatus = {
  FIRST_ACCESS: 'first_access',
  NOTIFICATION: 'notification',
  CLOSED: 'closed',
  LOADING: 'loading',
}

export const ROUTES = {
  HOME: '/',
  LOGIN_CALLBACK: '/login/callback',
  ERROR: '/error',
  PERFIL_CODIGO_ACESSO: '/perfil/codigo-acesso',
  PERFIL_DADOS_PESSOAIS: '/perfil/dados-pessoais',
  PERFIL_RESPONSAVEIS_VINCULADOS: '/perfil/responsaveis-vinculados',
  PERFIL_DADOS_ESCOLARES: '/perfil/dados-escolares',
  PERFIL_ALUNOS_VINCULADOS: '/perfil/alunos-vinculados',
  PERFIL_DADOS_ESCOLARES_FUNCOES: '/perfil/dados-escolares/funcoes',
  PERFIL_DADOS_ESCOLARES_FUNCOES_PROFESSOR_SEGMENTO:
    '/perfil/dados-escolares/funcoes/professor/segmento/',
  PERFIL_DADOS_ESCOLARES_FUNCOES_COORDENADOR: '/perfil/dados-escolares/funcoes/coordenador',
  PERFIL_DADOS_ESCOLARES_FUNCOES_PROFESSOR: '/perfil/dados-escolares/funcoes/professor',
  PERFIL_APROVACAO_CONTA: '/perfil/aprovacao-conta',
  PERFIL_PRIVACIDADE: '/perfil/privacidade',
  PERFIL_COMUNICACOES: '/perfil/comunicacoes',
  PERFIL_TERMOS_DE_USO: '/perfil/termos-de-uso',
}

export const USER_PRIVACY_PREFERENCES_CHANNELS = {
  email: 'MAIL',
  whatsapp: 'WHATSAPP',
  pushNotifcations: 'PUSH',
  inApp: 'IN_APP',
}

export const COMPLETED_USER_ID = 1
export const USER_STATUS_UPDATE_NOT_REQUIRED_TO_LOGIN = 5

export const ROLE_ADMIN_ID = 1
export const ROLE_TEACHER_ID = 3
export const ROLE_COORDINATOR_ID = 4
export const ROLE_DIRECTOR_ID = 5
export const ROLE_STUDENT_ID = 6
export const ROLE_ATTENDANT_ID = 21

export const ROLE_STATUS_ACTIVE_ID = 1
export const ROLE_STATUS_INACTIVE_ID = 2
export const ROLE_STATUS_PENDING_ID = 3
export const ROLE_STATUS_DISAPPROVED_ID = 5
export const ROLE_STATUS_DELETED_ID = 6

export const POSITION_CLASS_STATUS_ID = 3

export const COOKIE_RESPONSIBLE_URL = 'cookie_responsible_url'
export const NOT_ALLOW_CATCH_RESPONSIBLE_EMAIL = '1'

export const SESI_APPLICATION_NAME = 'SESI'

export const MACKENZIE_HYBRIDA_APPLICATION_ID = 306

export const MACKENZIE_PROPRIA_APPLICATION_ID = 364

export const SEDUC_MT_APPLICATION_ID = 309

export const APPLICATION_NAMES_CAN_CHANGE_CLASSES_AND_LEVELS = 'Mackenzie'

export const LOCAL_STORAGE_CURRENT_SCHOOL = 'currentSchool'
